type AddParams = {
    /** id товара */
    id: number;
    /** цены товара */
    price: {old: number; current: number};
    /** количество товара */
    count: number;
    /** применяется глобальная скидка или нет */
    discount: boolean;
    /**
     * оптовые цены, каждый элемент описывается масивом:
     * первый элемент - количество, второй - цена за штуку, если товаров
     * больше чем соответствующее количество
     */
    optPrices?: number[][];
    options?: {
        disableMetrika?: boolean;
    };
};

class CartModule {
    public reset() {
        window.CartKlen?.flush();
    }

    public remove(id: number) {
        window.CartKlen?.remove(id);
    }

    public update(params: AddParams) {
        window.CartKlen?.update({
            ...params,
            noSale: Number(!params.discount),
        });
    }
}

export const Cart = new CartModule();
